import * as React from 'react';
import { RouteComponentProps, withRouter, Link } from 'react-router-dom';
import { Redirect } from 'react-router';
import axios from '../../helpers/axios';
import { ToastContainer, toast } from 'react-toastify';
import { Grid, Card, CardContent, CardHeader, IconButton, Button, Avatar, Menu, MenuItem, Typography, FormControl, OutlinedInput, TextField, CardActions, Dialog, DialogTitle, DialogActions, Backdrop, CircularProgress } from '@mui/material';
// import 'react-toastify/dist/ReactToastify.css';
import { withTranslation, WithTranslation } from 'react-i18next';
import PaymentsHeader from './PaymentsHeader';
import { DataGrid, GridRowParams, GridActionsCellItem, GridCellParams } from '@mui/x-data-grid';
import { EditOutlined, Add, Security as SecurityIcon, FileCopy as FileCopyIcon, KeyboardArrowLeftRounded, MoreHorizOutlined, SendOutlined } from '@mui/icons-material';

export interface IProps {
    user: {
        id: number;
        name: string;
        email: string;
        role: string;
        is_active: boolean;
        selectedHierarchyIds: any;
    };
}

export interface IState {
    customer_id: string;
    pageSize: number;
    anchorEl: any;
    customers: any[];
    payment_pending_pickups: any;
    showLoader: boolean;
    showDialogBox: boolean;
    rowInformation: any;
    status: any;
}

class PaymentsForReview extends React.Component<RouteComponentProps<any> & IProps & WithTranslation, IState> {
    constructor(props: RouteComponentProps & IProps & WithTranslation) {
        super(props);
        this.state = {
            customer_id: this.props.match.params.id,
            pageSize: 5,
            anchorEl: null,
            customers: [],
            payment_pending_pickups: [],
            showLoader: false,
            showDialogBox: false,
            rowInformation: '',
            status: '',
        }
    }
    public componentDidMount(): void {
        // axios.get(`routes`).then(response => {
        //     this.setState({ routes: response.data.data })
        // });
        this.fetchPendingPayments();
    }

    public fetchPendingPayments = () => {
        this.setState({showLoader: true});
        axios.get('pendingPayments', { params: { "hierarchies": this.props.user.selectedHierarchyIds } }).then((resp: any) => {
            if(resp.data.success){
                console.log("response", resp.data.data);
                this.setState({showLoader: false});
                this.setState({payment_pending_pickups: resp.data.data?.map((el: any) => {
                    return{
                        "id": el.id,
                        "user_id": el.user_id,
                        "pickup_id": el.complete_weight.pickup_id,
                        "weight": el.complete_weight.total,
                        "pickup_date": el.pickup_date,
                        "pickup_total": el.pickup_total,
                    }
                })})
            } else {
                this.setState({ showLoader: false });
                toast.error(resp.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
                let errors = resp.data.errors;
                for (var error in errors) {
                    toast.error(errors[error][0], {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                } 
            }
        }).catch((err) => console.log("err",err))
    }

    public handlePublishPayments = (row: any, status: any) => {
        let data = {
            "pickup_id": row.pickup_id,
            "user_id": row.user_id,
            "status": status,
        }
        axios.post('publishPendingPayments', data, {headers: {"content-Type": "application/json"}}).then((response: any) => {
            if(response.data.success){
                toast.success(response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
                this.fetchPendingPayments();
                this.setState({rowInformation: '', status: '', showDialogBox: false});
            } else {
                toast.error(response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
                let errors = response.data.errors;
                for (var error in errors) {
                    toast.error(errors[error][0], {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                }
                this.setState({rowInformation: '', status: '', showDialogBox: false});
            }
        })
    }

    public render() {
        if (!localStorage.getItem('token')) {
            return (
                <Redirect to="/login" />
            );
        }
        const { t } = this.props;
        const open = Boolean(this.state.anchorEl);

        const columns = [
            {
                headerName: "PickupID",
                field: "id",
                width: 100,
              },
              {
                headerName: "UserID",
                field: "user_id",
                width: 150,
              },
              {
                headerName: "Pickup Total",
                field: "pickup_total",
                width: 150,
              },
              {
                headerName: "Weight",
                field: "weight",
                width: 150,
              },
              {
                headerName: "Pickup Date",
                field: "pickup_date",
                width: 180,
              },
              {
                headerName: "Actions",
                field: "actions",
                type: "actions",
                width: 350,
                renderCell: (params: GridCellParams) => (
                    <Grid container spacing={2}>
                        <Grid item md={6} xs={12}>
                            {/* <Link to={`/neighbourhood/community-list/${params.id}/users`} style={{ textDecoration: 'none' }}> */}
                                <Button
                                    variant="contained"
                                    size="small"
                                    className="float-right"
                                    tabIndex={params.hasFocus ? 0 : -1}
                                    onClick={() => this.handlePublishPayments(params.row, 'publish')}
                                    >
                                    Publish Payment
                                </Button>
                            {/* </Link> */}
                        </Grid>
                        <Grid item md={6} xs={12}>
                            {/* <Link to={`/neighbourhood/community-list/${params.id}/users`} style={{ textDecoration: 'none' }}> */}
                                <Button
                                    variant="contained"
                                    size="small"
                                    className="float-right"
                                    tabIndex={params.hasFocus ? 0 : -1}
                                    onClick={() => this.setState({showDialogBox: true, rowInformation: params.row, status: 'cancel'})}
                                    >
                                    Cancel Payment
                                </Button>
                            {/* </Link> */}
                        </Grid>
                    </Grid>
                    
                )
              }
            ]

        return (
            <div>
                <Backdrop
                    sx={{ zIndex: (theme) => theme.zIndex.drawer + 1000 }}
                    open={this.state.showLoader}
                    // onClick={() => this.setState({ showLoader: false })}
                >
                    <CircularProgress className='customLoader' />
                </Backdrop>
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={true}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
                <PaymentsHeader user={this.props.user} />
                <Grid container spacing={2}>
                    <Grid item md={12} xs={12} className="mt-3">
                        <Card>
                            <CardHeader
                                title="Payments For Review List"
                                className="text-left"
                                // action={
                                //     <CardActions>
                                //         <Button variant="contained" color="primary" size="small" sx={{ outline: 'none !important' }}>
                                //             <SendOutlined /> &nbsp; Send SMS Reminder
                                //         </Button>
                                //     </CardActions>
                                // }
                            />

                            <CardContent>
                                {/* <DataGrid
                                    aria-label="Overdue Customers List"
                                    columns={columns}
                                    rows={this.state.customers}
                                    pageSize={this.state.pageSize}
                                    onPageSizeChange={(newPageSize) => this.setState({ pageSize: newPageSize })}
                                    rowsPerPageOptions={[2, 5, 10, 20]}
                                    autoHeight={true}
                                    checkboxSelection
                                    onRowClick={(params: GridRowParams) => {
                                        this.props.history.push('/customers/' + params.id)
                                    }}
                                    className="clickableList"
                                /> */}
                                <DataGrid
                                    aria-label="Payments For Review List"
                                    columns={columns}
                                    rows={this.state.payment_pending_pickups}
                                    // pageSize={this.state.pageSize}
                                    // onPageSizeChange={(newPageSize) => this.setState({ pageSize: newPageSize })}
                                    // rowsPerPageOptions={[2, 5, 10, 20]}
                                    autoHeight={true}
                                    components={{
                                        MoreActionsIcon: EditOutlined,
                                    }}
                                    onRowClick={(params: GridRowParams) => {
                                        this.props.history.push('/operations/batch-pickups/group-pickups/pickup-details/' + params.id)
                                    }}
                                    className="clickableList"
                                />
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
                <Dialog
                    open={this.state.showDialogBox}
                    onClose={() => this.setState({ showDialogBox: false })}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {t("Are you sure ? You want to cancel this payment")}
                    </DialogTitle>
                    <DialogActions>
                        <Button onClick={() => this.setState({ showDialogBox: false, status: '', rowInformation: '' })}>{t("Cancel")}</Button>
                        <Button onClick={() => this.handlePublishPayments(this.state.rowInformation, this.state.status)} autoFocus>{t("Ok")}</Button>
                    </DialogActions>
                </Dialog>
            </div>
        )
    }
}

export default withRouter(withTranslation()(PaymentsForReview))